import { deleteConfirmModal } from "@helpers/DeleteValidate";
import { errorHandler } from "@helpers/errorHandler";
import { Call } from "@helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "@redux/actions/administrador/ui/ui";
import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";

// resources/src/redux/slices/users/Opportunities.js

const initialState = {
    list: [],
    active: null,
    activeDashboard: null,
    pagination: {
        current_page: 1,
        per_page: 15,
        total: 0,
        last_page: 1,
    },
};

const opportunitiesSlice = createSlice({
    name: "opportunities",
    initialState,
    reducers: {
        setList(state, action) {
            state.list = action.payload;
        },
        unsetList(state) {
            state.list = initialState.list;
        },
        setActive(state, action) {
            state.active = action.payload;
        },
        unsetActive(state) {
            state.active = initialState.active;
        },
        setActiveDashboard(state, action) {
            state.activeDashboard = action.payload;
        },
        unsetActiveDashboard(state) {
            state.activeDashboard = initialState.activeDashboard;
        },
        setPagination(state, action) {
            state.pagination = action.payload;
        },
        unsetPagination(state) {
            state.pagination = initialState.pagination;
        },
        reset(state) {
            Object.assign(state, initialState);
        },
    },
});

export const {
    setList,
    unsetList,
    setActive,
    unsetActive,
    setActiveDashboard,
    unsetActiveDashboard,
    setPagination,
    unsetPagination,
    reset,
} = opportunitiesSlice.actions;

export default opportunitiesSlice.reducer;

export const startShowOpportunities = ({
    page = 1,
    query = "",
    number_rows = 10,
    enterprise_id,
    asList = false,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("page", page);
        params.set("q", query);
        params.set("per_page", number_rows);
        params.set("enterprise_id", enterprise_id);
        if (asList) params.set("list", true);

        const resp = await Call(
            "users/opportunities/show",
            "GET",
            params.toString()
        );

        if (resp.success) {
            if (asList) {
                dispatch(setList(resp.success));
            } else {
                dispatch(setPagination(resp.success));
            }
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startShowOpportunityById = (
    opportunity_id,
    callback = () => {},
    onError = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `users/opportunities/${opportunity_id}/detail`,
            "GET"
        );

        if (resp.success) {
            dispatch(setActive(resp.success.opportunity));
            dispatch(setActiveDashboard(resp.success.dashboard));
            callback(resp.success);
        } else {
            errorHandler(resp);
            onError();
        }

        dispatch(stopUILoading());
    };
};

export const startCreateOpportunity = (
    values,
    callback = () => {},
    setErrors = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call("users/opportunities/create", "POST", values);

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Oportunidad creada correctamente.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 5000,
            });

            callback();
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startUpdateOpportunity = (
    opportunity_id,
    values,
    callback = () => {},
    setErrors = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `users/opportunities/edit/${opportunity_id}`,
            "POST",
            values
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Oportunidad actualizada.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 5000,
            });

            callback();
            dispatch(setActive(resp.success));
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startDeleteOpportunity = (opportunity_id, callback = () => {}) => {
    return async (dispatch) => {
        await deleteConfirmModal(async () => {
            dispatch(startUILoading());

            const resp = await Call(
                `users/opportunities/delete/${opportunity_id}`,
                "DELETE"
            );

            if (resp.success) {
                Swal.fire({
                    title: "Eliminada",
                    text: "La oportunidad fue eliminada.",
                    icon: "success",
                    toast: true,
                    position: "bottom-end",
                    timer: 5000,
                });

                callback();
            } else {
                errorHandler(resp);
            }

            dispatch(stopUILoading());
        });
    };
};
